import React, { Component } from 'react'
import ReactDOMServer from 'react-dom/server';
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { showPasswordlessLogin } from '../../libs/authService'
import MyTripStatic from './MyTripStatic'

import PropTypes from 'prop-types'
import get from 'lodash/get'
import _ from 'lodash'
import Download from '@axetroy/react-download';
import Loader from '../UI/Loader'
import TripDate from './TripDate'
import { pdfCrowdConfig } from '../../config'

import GET_CUSTOMIZED_PLAN from './../../graphql/TripPlanner/GetCustomizedPlan.graphql'

class MyTripPdf extends Component {
  static propTypes = {
    userQuery: PropTypes.object,
    customizedPlanQuery: PropTypes.shape({
      CustomizedPlan: PropTypes.shape({
        tripGuru: PropTypes.shape({
          id: PropTypes.string
        }),
        orderingUser: PropTypes.shape({
          id: PropTypes.string
        })
      })
    }),
    history: PropTypes.object,
    t: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      waiting: true,
      planPdf: null
    }
  }

  authenticateToView() {
    window.localStorage.setItem('authRedirect', window.location.pathname)
    showPasswordlessLogin()
  }

  renderTripDates() {
    const customizedPlan = this.props.plan
    const days = get(customizedPlan, 'tripDetails.itineraryDays', [])
    return days.map((day, i) => <TripDate key={i} day={day} customizedPlanId={customizedPlan.id} expand={true}/>)
  }

  getPdfFromApi(planId) {
    const planUrl = 'https://gettrip.guru/my-trips/x12W/' + planId
    const requestUrl = null
    fetch(requestUrl, { 
      method: 'post', 
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded'
      }), 
      body: 'url=' + planUrl
    })
    .then(response => {
      if (response.ok) {
        return response.blob()
      }
    })
    .then(function(myBlob) { 
      console.log("Got a blob")
    })
    .catch(function(error) {
      console.log('There has been a problem with pdf fetch operation: ', error.message);
    })
  }


  componentWillReceiveProps(next) {
    if (!next.loading && !next.user) {
      this.authenticateToView()
    } else if (!next.customizedPlanQuery.loading && next.customizedPlanQuery.CustomizedPlan) {
      const { CustomizedPlan } = next.customizedPlanQuery

      const validIds = []

      if (CustomizedPlan.tripGuru) {
        validIds.push(CustomizedPlan.tripGuru.id)
      }

      if (CustomizedPlan.orderingUser) {
        validIds.push(CustomizedPlan.orderingUser.id)
      }

      if (next.user && validIds.indexOf(next.user.id) === -1) {
        this.props.history.push('/')
      }

      this.setState({waiting: false})

      // Initiate the fetch
      this.getPdfFromApi(CustomizedPlan.id)
    }
  }

  render() {
    if (this.state.waiting) {
      return <Loader showLoader={true} />
    }

    // User ok generate pdf file
    //let planHtml = ReactDOMServer.renderToStaticMarkup(<MyTripStatic user={this.props.user} plan={this.props.customizedPlanQuery.CustomizedPlan} {...this.props} />)
    let planHtml = ReactDOMServer.renderToStaticMarkup(
      <div className="container my-trip">
        <MyTripStatic user={this.props.user} plan={this.props.customizedPlanQuery.CustomizedPlan} {...this.props} />
        <Download file="test.md" content="# hello world">
          <button type="button">Click and Download file</button>
        </Download>     
      </div>
    )
    console.log('plan html ready')

    return (
      <div className="container my-trip">
        <MyTripStatic user={this.props.user} plan={this.props.customizedPlanQuery.CustomizedPlan} {...this.props} />
        <Download file="test.md" content="# hello world">
          <button type="button">Click and Download file</button>
        </Download>     
      </div>
    )
  }
}

export default compose(
  graphql(GET_CUSTOMIZED_PLAN, {
    name: 'customizedPlanQuery',
    options: props => ({
      variables: {
        id: props.match.params.id
      }
    })
  }),
  translate('my_trip')
)(MyTripPdf)



// WEBPACK FOOTER //
// src/components/MyTrip/MyTripPdf.js